
import TopNavbar from "@/components/TopNavbar";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavbar />
      <main className="pt-16">{children}</main>
    </div>
  );
};

export default Layout;
